<template>
  <el-form :rules="rules" :model="inputForm" ref="inputForm" id="form" action="/password/reset" method="post">
    <p class="note mt-20 mb-m10">{{ $t('password') }}（{{ $t('format_password') }}）</p>
    <div class="text-danger" v-if="role === false"><span>{{ $t('change_password.check_password') }}</span></div>
    <el-form-item prop="password" :class="[isErrorForField('password', errors) ? 'is-error' : '']">
      <el-input :placeholder="$t('password')" v-model="inputForm.password" name="password" :type="typeInput"/>
      <div class="el-form-item__error text-error" v-if="isErrorForField('password', errors)">{{ getErrorForField('password', errors) }}</div>
    </el-form-item>
    <el-form-item prop="passwordConfirm">
      <el-input :placeholder="$t('password_confirm')" v-model="inputForm.passwordConfirm" :type="typeInput"/>
    </el-form-item>
    <el-checkbox v-model="isShowPassword" :label="$t('show_password')" size="small" @change="showPassword" class="mt-10"/>
    <input type="hidden" name="_token" :value="csrf">
    <input type="hidden" name="token" :value="token">
    <div class="form-footer">
      <el-button class="btn-reset" @click="reset('inputForm')">{{ $t('btn_reset_password') }}</el-button>
    </div>
  </el-form>
</template>
<script>
  export default {
    props: {
      errors: { type: Object, required: false },
      token: { type: String, required: true},
      role: { type: Boolean, required: true, default: true },
    },
    data() {
      const checkPasswordConfirm = (rule, value, callback) => {
        if (value !== this.inputForm.password) {
          callback(new Error(this.$t('errors.password.confirm')));
        } else {
          callback();
        }
      };
      const checkRegexPassword = (rule, value, callback) => {
        const regex = new RegExp(/^(?=.*[0-9])(?=.*[A-Z|a-z])(?=.*[\!\@\#\$\%\^\&\*\(\){\}[\]:\;\<\>\,\.\?\/~\_\+\-\=\\])[a-zA-Z0-9\!\@\#\$\%\^\&\*\(\){\}[\]:\;\<\>\,\.\?\/~\_\+\-\=\\]{8,255}$/);
        if (!regex.test(value)) {
          callback(new Error(this.$t('errors.password.format')));
        } else {
          callback();
        }
      }
      return {
        inputForm: {
          password: "",
          passwordConfirm: ""
        },
        rules: {
          password: [
            { required: true, message: this.$t('errors.required', [this.$t('password')]), trigger: 'blur' },
            { min: 8, message: this.$t('errors.min', [this.$t('password'), 8]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.max', [this.$t('password'), 255]), trigger: 'blur' },
            { validator: checkRegexPassword, trigger: 'blur' },
          ],
          passwordConfirm: [
            { required: true, message: this.$t('errors.required', [this.$t('password_confirm')]), trigger: 'blur' },
            { validator: checkPasswordConfirm, trigger: 'blur' },
          ]
        },
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        isShowPassword: false,
        typeInput: 'password'
      }
    },
    methods: {
      reset(formName) {
        if (document.querySelector(".text-error")) {
          document.querySelector(".text-error").style.display = "none";
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const form = document.getElementById("form");
            form.submit();
          } else {
            return false;
          }
        });
      },

      isErrorForField(field, errors) {
        return !(errors == null || errors.length == 0 || !errors.hasOwnProperty(field));
      },

      getErrorForField (field, errors) {
        return errors[field][0];
      },

      showPassword() {
        this.$refs.inputForm.clearValidate();
        this.typeInput = this.isShowPassword ? 'text' : 'password';
      }
    },
  }
</script>

<style lang="scss" scoped>
.el-form {
  width: 100%;
  .el-input {
    width: 400px;
  }
  .text-danger {
    white-space: pre-line;
    color: #AC3B29;
    font-size: 13px;
    letter-spacing: 1.3px;
    line-height: 21px;
    margin-top: 12px;
    margin-bottom: -10px;
  }
}
</style>
